import React, { useState } from "react";
import { Select, Input, Button, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "../Styles/UserStylings/ProductFilterList.css";

const { Option } = Select;

function ProductFilterList({ filters, onFilterChange, categories }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const priceRanges = [
    { label: "₹500-1000", value: "500-1000" },
    { label: "₹1500-3000", value: "1500-3000" },
    { label: "₹3500-5000", value: "3500-5000" },
    { label: "₹5000+", value: "5000-1000000" },
  ];
  const stockOptions = [
    { label: "In Stock", value: "in" },
    { label: "Low Stock (<10)", value: "low" },
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const handleSearch = () => {
    onFilterChange({
      ...filters,
      category: selectedCategory,
      search: searchTerm.trim(),
    });
  };

  return (
    <div className="filtering-section">
      <Row
        align="middle"
        justify="space-between"
        gutter={[16, 16]}
        className="filter-row"
      >
        {/* 🔹 Left: Price Filter */}
        <Col xs={24} sm={12} md={6} lg={5}>
          <Select
            placeholder="Price Range"
            className="filter-select"
            value={filters.price}
            onChange={(val) => handleFilterChange("price", val)}
            style={{ width: "100%", height: 40 }}
          >
            <Option value="">All Prices</Option>
            {priceRanges.map((range) => (
              <Option key={range.value} value={range.value}>
                {range.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* 🔹 Center: Amazon-style search bar */}
        <Col xs={24} sm={24} md={12} lg={10} style={{ textAlign: "center" }}>
          <div className="amazon-searchbar">
            <Select
              className="category-select"
              value={selectedCategory || undefined}
              onChange={(val) => setSelectedCategory(val)}
              placeholder="All"
              bordered={false}
              dropdownMatchSelectWidth={false}
            >
              <Option value="">All Categories</Option>
              {categories.map((cat) => (
                <Option key={cat.id} value={cat.name}>
                  {cat.name}
                </Option>
              ))}
            </Select>

            <Input
              className="search-input"
              placeholder="Search for products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <Button
              className="search-button"
              icon={<SearchOutlined style={{ fontSize: 18 }} />}
              onClick={handleSearch}
            />
          </div>
        </Col>

        {/* 🔹 Right: Stock Filter */}
        <Col xs={24} sm={12} md={6} lg={5}>
          <Select
            placeholder="Stock"
            className="filter-select"
            value={filters.stock}
            onChange={(val) => handleFilterChange("stock", val)}
            style={{ width: "100%", height: 40 }}
          >
            <Option value="">All Stock</Option>
            {stockOptions.map((stock) => (
              <Option key={stock.value} value={stock.value}>
                {stock.label}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </div>
  );
}

export default ProductFilterList;
